declare namespace $ {

	type $shm_service_task_list__title_shm_projects_tasks_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_service_task_list['title'] >
	>
	type $shm_service_task_list__add_title_shm_projects_tasks_2 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_service_task_list['add_title'] >
	>
	type $shm_service_task_list__filter_shm_projects_tasks_3 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['filter'] >
		,
		ReturnType< $shm_service_task_list['filter'] >
	>
	type $shm_service_task_list__add_shm_projects_tasks_4 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_add'] >
		,
		ReturnType< $shm_service_task_list['add'] >
	>
	type $shm_service_task_list__add_enabled_shm_projects_tasks_5 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_add_enabled'] >
		,
		ReturnType< $shm_service_task_list['add_enabled'] >
	>
	type $shm_service_task_list__task_rows_shm_projects_tasks_6 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_rows'] >
		,
		ReturnType< $shm_service_task_list['task_rows'] >
	>
	type $shm_service_task_list__task_arg_shm_projects_tasks_7 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_arg'] >
		,
		ReturnType< $shm_service_task_list['task_arg'] >
	>
	type $shm_service_task_list__task_title_shm_projects_tasks_8 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_title'] >
		,
		ReturnType< $shm_service_task_list['task_title'] >
	>
	type $shm_service_task_list__task_meta_shm_projects_tasks_9 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_meta'] >
		,
		ReturnType< $shm_service_task_list['task_meta'] >
	>
	type $shm_service_task_list__task_marker_rows_shm_projects_tasks_10 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_marker_rows'] >
		,
		ReturnType< $shm_service_task_list['task_marker_rows'] >
	>
	type $shm_service_task_list__task_current_shm_projects_tasks_11 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_current'] >
		,
		ReturnType< $shm_service_task_list['task_current'] >
	>
	type $shm_service_task_list__task_open_shm_projects_tasks_12 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_open'] >
		,
		ReturnType< $shm_service_task_list['task_open'] >
	>
	type $shm_service_task_list__task_pinned_shm_projects_tasks_13 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_pinned'] >
		,
		ReturnType< $shm_service_task_list['task_pinned'] >
	>
	type $shm_service_task_list__task_archived_shm_projects_tasks_14 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_archived'] >
		,
		ReturnType< $shm_service_task_list['task_archived'] >
	>
	type $shm_service_task_list__task_is_new_shm_projects_tasks_15 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_service_task_list['task_is_new'] >
	>
	type $shm_service_task_list__sort_by_shm_projects_tasks_16 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['sort_by'] >
		,
		ReturnType< $shm_service_task_list['sort_by'] >
	>
	type $shm_service_task_list__sort_order_shm_projects_tasks_17 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['sort_order'] >
		,
		ReturnType< $shm_service_task_list['sort_order'] >
	>
	type $mol_text__text_shm_projects_tasks_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__attr_shm_projects_tasks_19 = $mol_type_enforce<
		({ 
			'title': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__attr_shm_projects_tasks_20 = $mol_type_enforce<
		({ 
			'title': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_projects_tasks_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_task__project_id_shm_projects_tasks_22 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['project_id'] >
		,
		ReturnType< $shm_projects_task['project_id'] >
	>
	type $shm_projects_task__task_id_shm_projects_tasks_23 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_id'] >
		,
		ReturnType< $shm_projects_task['task_id'] >
	>
	export class $shm_projects_tasks extends $mol_book2 {
		task_pages( ): readonly(any)[]
		task_add( next?: any ): any
		task_rows( ): readonly(any)[]
		task_arg( id: any): Record<string, any>
		task_title( id: any): string
		task_meta( id: any): string
		task_marker_rows( id: any): readonly(any)[]
		task_current( id: any): boolean
		task_open( id: any, next?: any ): any
		task_pinned( id: any, next?: boolean ): boolean
		task_archived( id: any, next?: boolean ): boolean
		sort_by( next?: string ): string
		sort_order( next?: string ): string
		task_id( id: any): string
		project_id( ): string
		filter( next?: string ): string
		task_add_enabled( ): boolean
		pages( ): ReturnType< $shm_projects_tasks['task_pages'] >
		List( ): $shm_service_task_list
		Empty( ): $mol_text
		Task_busy( id: any): $mol_view
		Task_updated( id: any): $mol_view
		Task( id: any): $shm_projects_task
	}
	
}

//# sourceMappingURL=tasks.view.tree.d.ts.map